import { Button, Dialog, DialogActions, Box, DialogContent, TextField, IconButton, DialogTitle, Typography, FormHelperText, Select, MenuItem, Divider } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { addMachineNote } from '../../../redux/machineNoteListSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/machines/addMachineNote.css';

const TYPE_OPTIONS = [
    { value: 'Securite', labelKey: 'Sécurité' },
    { value: 'Maintenance', labelKey: 'Maintenance' },
    { value: 'Information', labelKey: 'Information' },
    { value: 'Autre', labelKey: 'Autre' },
];

export const AddMachineNote = ({ openAddNote, setOpenAddNote }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const machineDetailsData = useSelector((state) => state?.MachineDetailsData);

    const [errMsg, setErrMsg] = useState(null);

    const formik = useFormik({
        initialValues: {
            machine_id: machineDetailsData.id,
            type: 'Information',
            message: ''
        },
        validationSchema: Yup.object().shape({
            machine_id: Yup.string().required(t('isRequired')),
            type: Yup.string().required(t('isRequired')),
            message: Yup.string().required(t('isRequired')),
        }),
        onSubmit: async (values) => {
            try {
                const { data, status } = await axios.post('machine-note', values);
                if (status === 200 || status === 201) {
                    dispatch(addMachineNote(data));
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Ajouter la remarque de la machine' }));
                    setOpenAddNote(false);
                }
            } catch (error) {
                setErrMsg(error.message);
                console.error('Error add machine note:', error);
                CustomErrorLogger(error, "error add machine note");
            }
        },
    });

    const { handleSubmit, values, touched, errors, handleChange, handleBlur, setFieldValue } = formik;

    const handleClose = useCallback(() => {
        setOpenAddNote(false);
        setFieldValue('type', '')
        setFieldValue('Message', '')
    }, [setOpenAddNote, setFieldValue]);

    return (
        <Dialog open={openAddNote} fullWidth maxWidth='md'>
            <IconButton onClick={handleClose} className='addMachineNote_icon_button'>
                <Iconify icon="material-symbols:close" className='addMachineNote_close_icon' />
            </IconButton>
            <DialogTitle className='addMachineNote_dialog_title'>Ajouter une remarque</DialogTitle>
            <Divider />
            <form onSubmit={handleSubmit}>
                {errMsg && <Typography className='errMsg'>{errMsg}</Typography>}
                <DialogContent className='addMachineNote_dialog_content'>
                    <Box className="addMachineNote_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addMachineNoteInputTitle">Type</FormHelperText>
                        <Select
                            className="addMachineNote_select_metier"
                            name="type"
                            fullWidth
                            value={values.type}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.type && Boolean(errors.type)}
                            displayEmpty
                            inputProps={{ 'aria-describedby': 'outlined-weight-helper-text' }}
                        >
                            {TYPE_OPTIONS.map(opt => (
                                <MenuItem key={opt.value} value={opt.value}>{t(opt.labelKey)}</MenuItem>
                            ))}
                        </Select>
                        {touched.type && errors.type && (
                            <FormHelperText error className='addMachineNote_err_helper_select'>{errors.type}</FormHelperText>
                        )}
                    </Box>
                    <Box className="addMachineNote_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addMachineNoteInputTitle">Message</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.message}
                            className='addMachineNote_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="message"
                            multiline
                            rows={6}
                            error={touched.message && Boolean(errors.message)}
                            helperText={touched.message && errors.message}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='addMachineNote_dialog_actions'>
                    <Button className='addMachineNote_button_annuler' onClick={handleClose}>{t('Annuler')}</Button>
                    <Button className='addMachineNote_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};